import LiveModal from 'live/components/ui/Modal'
import styled from "styled-components"

const ImportSummaryModal = styled(LiveModal)`
.modal-dialog {
    width: 900px;
    height: 547px;
}
.modal-body {
    //height: 500px;
    //max-height: 900px;
    background-color: ${({ theme }) => theme['gray-200']};
}

.RecipientImportSummary {
    &__body {
        &__content {
            font-weight: 400;
            &__infos {
                font-size: 14px;
                &__message {
                    &-INFO {
                        margin: 5px;
                        span {
                            color: ${({ theme }) => theme['gray-800']};
                        }
                    }
                    &-WARN {
                        margin: 5px;
                        span {
                            color: ${({ theme }) => theme['red-500']};
                        }
                    }
                }
            }
            &__flags {
                &__keepDeleted {
                    input[type=checkbox] {
                        margin: 3px 3px 0px 5px;
                    }
                }
                &__overrideUpdated {
                    input[type=checkbox] {
                        margin: 3px 3px 0px 5px;
                    }
                }
            }
            &__changesTable {
                width: 100%;
                margin: 5px;
                font-family: 'Source Sans Pro';
                font-style: normal;
                font-size: 12px;
                    
                &__header {
                    background-color: ${({ theme }) => theme['gray-100']};
                    border: 1px solid ${({ theme }) => theme['gray-300']};
                    border-top-right-radius: 3px;
                    border-top-left-radius: 3px;
                    border-bottom: 0px;
                    /* identical to box height, or 145% */
                    text-transform: uppercase;
                    color: ${({ theme }) => theme["gray-700"]};

                    display: flex;
                    justify-content: flex-start;
                    
                    div {
                        padding: 4px 8px 4px 4px;
                    }
                }
                &__body {
                    height: 250px;
                    overflow: hidden;
                    overflow-y: auto;
                    width: 100%;
                    background-color: ${({ theme }) => theme['gray-0']};
                    &__row {
                        display: flex;
                        justify-content: flex-start;
                        border: 1px solid ${({ theme }) => theme['gray-300']};
                        div {
                            padding: 4px 8px 4px 16px;
                        }
                    }
                }
                &__col1 {
                    //border: 2px solid blue;
                    width: 30%;
                }
                &__col2 {
                    //border: 2px solid green;
                    width: 20%;
                }
                &__col3 {
                    //border: 2px solid yellow;
                    width: 15%;
                }
                &__col4 {
                    //border: 2px solid red;
                    width: 15%;
                }
                &__col5 {
                    //border: 2px solid black;
                    width: 15%;
                }
            
                &__errosNumber {
                    &-withErrors{
                        color: ${({ theme }) => theme['red-500']};
                        i {
                            margin-left: 8px;
                            font-family: 'Font Awesome 5 Pro';
                            transition: all 0.3s;
                            color: ${({ theme }) => theme['red-500']};
                            cursor: pointer;
                            :hover {
                                color: ${({ theme }) => theme['red-400']};
                            }
                        }
                    }
                }
                &__action {
                    &-DELETED {
                        color: ${({ theme }) => theme['red-500']};
                    }
                    &-PRESERVED {
                        color: ${({ theme }) => theme['gray-700']};
                    }
                    &-ADDED {
                        color: ${({ theme }) => theme['green-700']};
                    }
                    &-UPDATED {
                        color: ${({ theme }) => theme['blue-700']};
                    }
                    &-OVERRIDED {
                        color: ${({ theme }) => theme['yellow-700']};
                    }
                }
            }
        }
    }
}
`

export default ImportSummaryModal